<template>
  <div class="simple-table" :style="{ width: width, height: height }">
    <VTable
      :allowMultiSelect="allowMultiSelect"
      :showIndex="showIndex"
      v-bind="$attrs"
      ref="vtableRef"
      :columns="columns"
      :data="tableData"
      :contextMenuMap="contextMenuMap"
      :dataConfig="dataConfig"
      @cell-change="handleCellEdit"
      @cell-dblclick="handleDblclick"
      @row-select="handleRowSelect"
      @backspace="handleBackspace"
    />
  </div>
</template>

<script>
import { tableMixin } from '@/utils/tableMixin.js'
import { debounceAfter } from '@/utils/index.js'

export default {
  name: 'SimpleTable',
  mixins: [tableMixin],
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    },
    showIndex: {
      type: Boolean,
      default: true
    },
    allowMultiSelect: {
      type: Boolean,
      default: true
    },
    columns: {
      type: Array,
      default: () => []
    },
    data: {
      type: Array,
      default: () => []
    },
    menus: {
      type: Array,
      default: () => ['查询', '批量修改']
    },
    menusMergeAfter: {
      type: Function,
      default: null
    },
    dataConfig: {
      type: Object,
      default: null
    },
    uploadParams: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      // 页面数据
      contextMenuMap: {}
    }
  },
  computed: {},
  watch: {
    data() {
      this.tableData = this.data
    },
    columns() {
      this.resetMenus()
    },
    menus: {
      handler() {
        this.resetMenus()
      },
      immediate: true
    }
  },
  created() {
    this.tableData = this.data
  },
  mounted() {
    // 页面初始化逻辑
  },
  methods: {
    resetMenus() {
      const map = {
        查询: () => this.handleSearch(),
        上传: () => this.handleUpload(),
        插入: () => this.handleInsert(),
        插入下级: () => this.handleInsertChild(),
        批量删除: () => this.handleDelete(),
        批量修改: () => this.handleEdit(),
        拷贝行: () => this.handleCopyRow(),
        插入拷贝行: () => this.handleInsertCopyRow(),
        // 复制本表: () => this.handleCopyTable(),
        '拷贝本表+子表': () => this.handleCopyTableChild(),
        '插入本表+子表': () => this.handleInsertTableChild(),
        插入剪切板内容: () => this.handleInsertCopyCell(),
        导出: () => this.handleExport()
        // 粘贴单元格: () => this.handleCopyCell()
      }

      for (const key in map) {
        this.contextMenuMap[key] = this.menus.includes(key) ? map[key] : null
      }
      if (this.menusMergeAfter) this.menusMergeAfter(this.contextMenuMap)
    },
    // 页面方法
    handleRowSelect(...args) {
      this.$emit('row-select', ...args)
    },

    onModifyDataChange: debounceAfter(async function () {
      this.$emit('modify-data-change', this.getModifyData, this.cleanModifyData)
    })
  }
}
</script>

<style scoped lang="less">
.simple-table {
}
</style>
